'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var userTypes = {
  INVESTOR: 'INVESTOR',
  ISSUER: 'ISSUER',
  ADVISOR: 'ADVISOR',
  ADMIN_STRATEGIC_PARTNER: 'ADMIN_STRATEGIC_PARTNER',
  WORKER_STRATEGIC_PARTNER: 'WORKER_STRATEGIC_PARTNER',
  COMPLIANCE_OFFICER_STRATEGIC_PARTNER: 'COMPLIANCE_OFFICER_STRATEGIC_PARTNER',
  OTHER_STRATEGIC_PARTNER: 'OTHER_STRATEGIC_PARTNER',
  ISSUER_STRATEGIC_PARTNER: 'ISSUER_STRATEGIC_PARTNER',
  INVESTOR_STRATEGIC_PARTNER: 'INVESTOR_STRATEGIC_PARTNER',
  SUPER_ADMIN: 'SUPER_ADMIN'
};
exports.default = userTypes;